<template>
  <div class="content-wrapper">
    <TheHeader class="main-header" />
    <main class="main-content">
      <router-view :key="$route.fullPath" />
      <TheFooter></TheFooter>
    </main>
  </div>
</template>

<script>
import TheHeader from '@/components/layout/home/TheHeader.vue'
import TheFooter from '@/components/layout/home/TheFooter.vue'

export default {
  components: {
    TheHeader,
    TheFooter
  }
}
</script>

<style lang="sass">
section
  background: $main-bg-color
  @apply text-center text-white
  &::after
    margin-bottom: 50px !important
.section-head
  @apply mb-4
  h2
    @apply text-6xl
  p
    @apply text-3xl px-4
.content-wrapper
    @apply flex

.main-content
  background: $main-bg-color
  section
    @apply mb-8 mt-20

@scrren sm
  .main-content
    background: $main-bg-color
    section
      @apply mb-0 mt-0

@screen md
  .main-header
    @apply h-screen sticky top-0 w-2/5
  .main-content
    @apply w-4/5

@screen xl
  .main-header
    @apply h-screen sticky top-0 w-3/12
  .main-content
    @apply w-9/12
</style>
